import { Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import PortalAdminRoute from './components/PortalAdminRoute';
import ShellLayout from './components/ShellLayout';
import { getIsPortalAdmin } from './utils/storage';
import { AppsProvider } from './contexts/AppsContext';
import AppsPage from './pages/AppsPage';
import ComponentsPage from './pages/ComponentsPage';
import DashboardPage from './pages/DashboardPage';
import LoginPage from './pages/LoginPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import RolesPage from './pages/RolesPage';
import TenantsPage from './pages/TenantsPage';
import UsersPage from './pages/UsersPage';
import InvitationsPage from './pages/InvitationsPage';
import ApiKeysPage from './pages/ApiKeysPage';
import GroupsPage from './pages/GroupsPage';
import DelegationsPage from './pages/DelegationsPage';
import AuditTrailPage from './pages/AuditTrailPage';
import TotpSetupPage from './pages/TotpSetupPage';
import WebhooksPage from './pages/WebhooksPage';
import SSOPage from './pages/SSOPage';

function App() {
    return (
        <div className="min-h-screen bg-slate-50 text-slate-900">
            <AppsProvider>
                <Routes>
                    <Route path="/" element={<Navigate to={getIsPortalAdmin() ? '/dashboard' : '/users'} replace />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/reset-password" element={<ResetPasswordPage />} />

                    <Route
                        element={
                            <ProtectedRoute>
                                <ShellLayout />
                            </ProtectedRoute>
                        }
                    >
                        <Route
                            path="/dashboard"
                            element={
                                <PortalAdminRoute>
                                    <DashboardPage />
                                </PortalAdminRoute>
                            }
                        />
                        <Route path="/apps" element={<AppsPage />} />
                        <Route path="/users" element={<UsersPage />} />
                        <Route path="/roles" element={<RolesPage />} />
                        <Route path="/components" element={<ComponentsPage />} />
                        <Route path="/tenants" element={<TenantsPage />} />
                        <Route path="/invitations" element={<InvitationsPage />} />
                        <Route path="/api-keys" element={<ApiKeysPage />} />
                        <Route path="/groups" element={<GroupsPage />} />
                        <Route path="/delegations" element={<DelegationsPage />} />
                        <Route path="/audit-trail" element={<AuditTrailPage />} />
                        <Route path="/totp-setup" element={<TotpSetupPage />} />
                        <Route path="/webhooks" element={<WebhooksPage />} />
                        <Route path="/sso" element={<SSOPage />} />
                    </Route>

                    <Route path="*" element={<div className="p-6">Not found</div>} />
                </Routes>
            </AppsProvider>
        </div>
    );
}

export default App;
